import { Button, Flex, Link, Text } from '@chakra-ui/react';
import CardBody from './Parts/CardBody';
import SimpleCard from './SimpleCard';
import NextLink from 'next/link';

function ActionProposalCard({ children, accentColor = null, width = null }) {
  return (
    <SimpleCard
      accentColor={accentColor ? accentColor + '.100' : 'brand.100'}
      bg={accentColor ? accentColor + '.25' : 'brand.25'}
      width={width ? width : '100%'}
    >
      <CardBody>
        <Flex direction="column" gap="1rem" align="center">
          {children}
        </Flex>
      </CardBody>
    </SimpleCard>
  );
}

export function ActionProposalCardLink({ children, href, buttonVariants }) {
  return (
    <NextLink href={href} passHref>
      <Button
        as="a"
        variant={buttonVariants ? buttonVariants : null}
        size={['sm', '', 'md']}
      >
        {children}
      </Button>
    </NextLink>
  );
}

export function ActionProposalCardText({ children, textCantWrap = false }) {
  return (
    <Text
      fontWeight="bold"
      whiteSpace={textCantWrap && 'nowrap'}
      fontSize={['1rem', '', '1.25rem']}
    >
      {children}
    </Text>
  );
}

export default ActionProposalCard;
